/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Iaso
 * Iaso Swagger
 * OpenAPI spec version: v1
 */
import { z as zod } from 'zod';

export const validationWorkflowListSlugRegExp = new RegExp('[-a-zA-Z0-9_]+');
export const validationWorkflowListNameMax = 256;

export const ValidationWorkflowList = zod.strictObject({
    slug: zod.string().regex(validationWorkflowListSlugRegExp),
    name: zod.string().max(validationWorkflowListNameMax),
    form_count: zod.number(),
    created_by: zod.string().nullable(),
    updated_by: zod.string().nullable(),
    created_at: zod.iso.datetime({ offset: true }),
    updated_at: zod.iso.datetime({ offset: true }),
});

export type ValidationWorkflowList = zod.input<typeof ValidationWorkflowList>;
export type ValidationWorkflowListOutput = zod.output<
    typeof ValidationWorkflowList
>;
